import { Action } from '@ngrx/store';
import { CustomizableAssets } from '@shared/shared/interfaces/custom-assets.interfaces';

export const GET_CUSTOM_ASSETS = '[Custom Assets] Get Custom Assets';
export const GET_CUSTOM_ASSETS_FAIL = '[Custom Assets] Get Custom Assets Fail';
export const GET_CUSTOM_ASSETS_SUCCESS = '[Custom Assets] Get Custom Assets Success';

export class GetCustomAssets implements Action {
  readonly type = GET_CUSTOM_ASSETS;
}

export class GetCustomAssetsFail implements Action {
  readonly type = GET_CUSTOM_ASSETS_FAIL;
  constructor(public payload: any) {}
}

export class GetCustomAssetsSuccess implements Action {
  readonly type = GET_CUSTOM_ASSETS_SUCCESS;
  constructor(public payload: CustomizableAssets) {}
}

export type CustomAssetsActions = GetCustomAssets | GetCustomAssetsFail | GetCustomAssetsSuccess;
